export const checkNumber = v => !isNaN(v);
